export * from '@primeuix/themes/material/chip';
export { default } from '@primeuix/themes/material/chip';
